import '../js/consolePoly'

import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'

import Routes from './Routes.js'
import root from './reducers'
import LibraryRoutes from './LibraryRoutes.js'

const middlewareSetup = () => applyMiddleware(thunk)
const store = createStore(root, middlewareSetup())
const wrapWithProviders = rootComponentFunc => {
  return <Provider store={store}>{rootComponentFunc(store)}</Provider>
}
const renderMainScreen = Routes => {
  const spaElement = document.getElementById('nocontent')

  if (spaElement) {
    ReactDOM.render(
      wrapWithProviders(() => <Routes store={store} />),
      spaElement
    )
  }

  const libraryElement = document.getElementById('librarycontent')

  if (libraryElement) {
    ReactDOM.render(
      wrapWithProviders(() => <LibraryRoutes store={store} />),
      libraryElement
    )
  }
}

renderMainScreen(Routes)

if (module.hot) {
  module.hot.accept('./Routes.js', () => {
    console.log('Accepting hot reload')
    /*
     * If you use Webpack 2 in ES modules mode, you can
     * use <App /> here rather than require() a <NextApp />.
     */
    const NextRoutes = require('./Routes.js').default
    renderMainScreen(NextRoutes)
  })
}
